import Link from "next/link";
import { ComponentProps } from "react";

import { links } from "@/data/links";
import { externalLinks } from "@/data/links/external-links";
import { useAuth } from "@/features/auth/shared/hooks/use-auth";
import { useLogout } from "@/features/auth/shared/services/logout";
import { useLang } from "@/hooks/use-lang";

import { PopoverButton } from "../PopoverButton";
import { LanguageSwitch } from "./LanguageSwitch";
import { UserInfo } from "./UserInfo";

type Props = ComponentProps<"section"> & {
  close: () => void;
  isDesktop?: boolean;
};

export const UserSection = ({ close, isDesktop, ...props }: Props) => {
  const { isAuthenticated } = useAuth();
  const { t, lang } = useLang();
  const { mutate: logout } = useLogout();
  return (
    <section {...props} aria-label="user popover" role="menu">
      <UserInfo />
      {isDesktop && <div className="border-t border-gray-100" />}
      {isAuthenticated && (
        <Link href={`/${lang}${links.myAccount}`} onClick={() => close()}>
          <PopoverButton>{t.layout.navbar.userSetting}</PopoverButton>
        </Link>
      )}
      <Link href={externalLinks.lineStockmining} onClick={() => close()}>
        <PopoverButton>{t.layout.navbar.line}</PopoverButton>
      </Link>
      {/* <Link href={externalLinks.telegram} onClick={() => close()}>
        <PopoverButton>{t.layout.navbar.telegram}</PopoverButton>
      </Link> */}
      <Link href={externalLinks.discord} onClick={() => close()}>
        <PopoverButton>{t.layout.navbar.discord}</PopoverButton>
      </Link>
      <LanguageSwitch />
      <div className="border-t border-gray-100" />
      {isAuthenticated ? (
        <PopoverButton
          onClick={() => {
            close();
            logout();
          }}
          aria-label="logout"
        >
          {t.layout.navbar.logout}
        </PopoverButton>
      ) : (
        <Link
          href={`/${lang}${links.authLogin}`}
          onClick={() => close()}
          aria-label="go to login page"
        >
          <PopoverButton>{t.layout.navbar.loginRegister}</PopoverButton>
        </Link>
      )}
    </section>
  );
};
